export enum Auth {
    PRIMARY_CTA = "Sign in",
}
